var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconYoutube24Filled = function SvgIconYoutube24Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 5.65H6.8c-1.46 0-2.65 1.19-2.65 2.65v7.4c0 1.46 1.19 2.65 2.65 2.65h10.4c1.46 0 2.65-1.19 2.65-2.65V8.3c0-1.46-1.19-2.65-2.65-2.65Zm-3.31 7.285-1.495 1.325a1.254 1.254 0 0 1-1.34.205c-.45-.2-.735-.65-.735-1.14v-2.65c0-.49.29-.94.735-1.14.445-.2.975-.12 1.34.205l1.495 1.325c.27.235.42.58.42.935 0 .355-.155.7-.42.935Z",
    fill: "current"
  })));
};
export default SvgIconYoutube24Filled;